/**
 * Instant Cart Fix for Shopify (v7)
 * - NO intercepta formularios (no hace add por su cuenta) -> evita duplicados
 * - Solo refresca tras mutaciones detectadas (hook global de fetch)
 * - /cart.js sin caché + reintentos breves (evita "carrito vacío")
 * - Mantiene eliminar/cambiar cantidad y actualización de contador + drawer
 */
(function () {
  if (window.__instantCartFixLoadedV7) return;
  window.__instantCartFixLoadedV7 = true;

  var DRAWER_SECTION_HANDLE = 'cart-drawer';
  var DRAWER_ROOT_SELECTOR  = '#CartDrawer, .mini-cart, .cart-drawer';
  var HEADER_BUBBLE_SELECTOR = '#cart-icon-bubble, .header__icon--cart, a[href="/cart"]';

  var CART_RETRY_MS     = [120, 220, 350];  // reintentos de /cart.js
  var FETCH_HOOK_DEBOUNCE = 250;            // coalescencia de múltiples adds/changes

  function sleep(ms){ return new Promise(r=>setTimeout(r,ms)); }

  async function safeFetch(url, options){
    var res = await fetch(url, options);
    if(!res.ok) throw new Error('HTTP '+res.status);
    return res;
  }

  async function fetchCartNoCache(){
    var url = new URL('/cart.js', location.origin);
    url.searchParams.set('_', Date.now().toString());
    var res = await safeFetch(url, {
      headers: { 'Accept':'application/json','Cache-Control':'no-store' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    return res.json();
  }

  async function getFreshCartWithRetries(){
    try {
      var c = await fetchCartNoCache();
      if (c && typeof c.item_count === 'number') return c;
    } catch(_){}
    for (var i=0;i<CART_RETRY_MS.length;i++){
      await sleep(CART_RETRY_MS[i]);
      try {
        var c2 = await fetchCartNoCache();
        if (c2 && typeof c2.item_count === 'number') return c2;
      } catch(_){}
    }
    return fetchCartNoCache();
  }

  function updateHeaderCount(cart){
    try{
      var bubbleLink = document.querySelector(HEADER_BUBBLE_SELECTOR);
      if(!bubbleLink) return;
      var count = cart.item_count || 0;

      var bubble = bubbleLink.querySelector('.cart-count-bubble');
      if(!bubble && count>0){
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        var span = document.createElement('span');
        span.setAttribute('aria-hidden','true');
        span.textContent = String(count);
        bubble.appendChild(span);
        bubbleLink.appendChild(bubble);
      } else if (bubble){
        if(count>0){
          (bubble.querySelector('span[aria-hidden]')||bubble.querySelector('span')).textContent = String(count);
        } else {
          bubble.remove();
        }
      }
      var live = bubbleLink.querySelector('.visually-hidden,.visualmente-oculto');
      if (live) live.textContent = (count===1) ? '1 artículo' : (count+' artículos');
    }catch(e){ console.warn('instant-cart-fix: header count', e); }
  }

  async function refreshCartDrawer(){
    var root = document.querySelector(DRAWER_ROOT_SELECTOR);
    if(!root) return;
    try{
      var html = await (await fetch('/?section_id='+DRAWER_SECTION_HANDLE, {credentials:'same-origin'})).text();
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector(DRAWER_ROOT_SELECTOR);
      if(fresh){ root.innerHTML = fresh.innerHTML; return; }

      var url = new URL(location.href); url.searchParams.set('sections', DRAWER_SECTION_HANDLE);
      var t = await (await fetch(url.toString(), {credentials:'same-origin'})).text();
      try{
        var data = JSON.parse(t);
        var k = Object.keys(data)[0]; var str = typeof data[k]==='string'?data[k]:'';
        if(str){ var t2 = document.createElement('div'); t2.innerHTML = str;
          var f2 = t2.querySelector(DRAWER_ROOT_SELECTOR); if(f2) root.innerHTML = f2.innerHTML;
        }
      }catch(_){
        var t3 = document.createElement('div'); t3.innerHTML = t;
        var f3 = t3.querySelector(DRAWER_ROOT_SELECTOR); if(f3) root.innerHTML = f3.innerHTML;
      }
    }catch(e){ console.warn('instant-cart-fix: refresh drawer', e); }
  }

  function openCartUI(){
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function'){ try{ drawer.open(); return; }catch(e){} }
    var notif = document.querySelector('cart-notification');
    if (notif && typeof notif.open === 'function'){ try{ notif.open(); return; }catch(e){} }
  }

  async function afterCartMutation(){
    var cart = await getFreshCartWithRetries();
    updateHeaderCount(cart);
    await refreshCartDrawer();
    openCartUI();
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles:true }));
  }

  /* ---------- Eliminar y cantidad (sí los gestionamos) ---------- */
  async function changeLine(line, qty){
    var res = await safeFetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Accept':'application/json','Content-Type':'application/json' },
      credentials:'same-origin',
      cache:'no-store',
      body: JSON.stringify({ line:Number(line), quantity:Number(qty) })
    });
    return res.json();
  }

  async function onRemoveClick(e){
    var host = e.target.closest('cart-remove-button,[data-index],[data-line]');
    if(!host) return;
    var btn = host.querySelector('button') || (e.target.tagName==='BUTTON'?e.target:null);
    if(!btn || !btn.contains(e.target)) return;
    var line = host.getAttribute('data-index') || host.getAttribute('data-line') || btn.getAttribute('data-line');
    if(!line) return;

    e.preventDefault(); btn.disabled = true;
    try{
      var cart = await changeLine(line, 0);
      updateHeaderCount(cart);
      await refreshCartDrawer();
      openCartUI();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles:true }));
    } finally { btn.disabled = false; }
  }

  var qtyTimer;
  function onQuantityChange(e){
    var container = e.target.closest(DRAWER_ROOT_SELECTOR);
    if(!container) return;
    var holder = e.target.closest('[data-index],[data-line]') || e.target;
    var line = holder && (holder.getAttribute('data-index') || holder.getAttribute('data-line'));
    if(!line) return;
    var input = e.target.matches('input') ? e.target : container.querySelector('input[name="updates[]"],input[type="number"]');
    if(!input) return;

    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(async function(){
      try{
        var cart = await changeLine(line, input.value);
        updateHeaderCount(cart);
        await refreshCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles:true }));
      }catch(err){ console.error('instant-cart-fix: qty', err); }
    }, 250);
  }

  // OJO: NO interceptamos 'submit' de formularios para evitar duplicados.
  // document.addEventListener('submit', onSubmit, true);

  document.addEventListener('click', onRemoveClick, true);
  document.addEventListener('change', onQuantityChange, true);

  /* ---------- Hook global de fetch (detecta adds/changes de tema/apps) ---------- */
  if (!window.__instantCartFetchHookedV7){
    window.__instantCartFetchHookedV7 = true;

    var origFetch = window.fetch;
    var hookTimer = null;

    window.fetch = function(input, init){
      var url = (typeof input==='string') ? input : (input && input.url) || '';
      var method = (init && init.method) || (typeof input!=='string' && input && input.method) || 'GET';
      var isMutation = /\/cart\/add(\.js)?(\?|$)/.test(url) || (/\/cart\/change(\.js)?(\?|$)/.test(url) && /POST/i.test(method));

      var p = origFetch.apply(this, arguments);

      if (isMutation){
        p.then(function(res){
          if(res && res.ok){
            clearTimeout(hookTimer);
            hookTimer = setTimeout(function(){
              afterCartMutation().catch(function(e){ console.warn('afterCartMutation hook', e); });
            }, FETCH_HOOK_DEBOUNCE);
          }
        }).catch(function(){});
      }

      return p;
    };
  }
})();
